function NoPage() {
    return(
        <div>
        <h1>ERROR 404 - The resource you requested is not found on Motomuver.com!</h1>
        <h1>Please check link again</h1>
        </div>
    )

}
export default NoPage;